import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import TopBar from './TopBar';
import Header from './Header';
import Hero from './Hero';
import About from './About';
import Products from './Products';
import Gallery from './Gallery';
import Contact from './Contact';
import FAQ from './components/FAQ'; 
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import Loader from './components/Loader.jsx';
import Catalog from './Catalog.jsx'; 
import FullGallery from './FullGallery.jsx'; 
import CartDrawer from './components/CartDrawer.jsx'; 
import { createWhatsAppMessage, getWhatsAppURL } from './utils/whatsappUtils';

import './index.css';

const HomePage = () => (
  <main>
    <section id="home" className="scroll-mt-[130px]">
      <Hero />
    </section>
    <Products />
    <Gallery />
    <About />
    <Contact />
  </main>
);

function App() {
  const [cart, setCart] = useState(() => {
    try {
      const saved = localStorage.getItem('miCarritoAbejas');
      return saved ? JSON.parse(saved) : [];
    } catch { return []; }
  });

  const [isCartOpen, setIsCartOpen] = useState(false);
  const [token, setToken] = useState(null); 
  
  // 1. ESTADO INICIAL ACTUALIZADO (Con notas y shippingZone)
  const [customer, setCustomer] = useState({ 
    name: '', lastName: '', calle: '', numExt: '', numInt: '', 
    colonia: '', cp: '', municipio: '', estado: '', pais: 'México', 
    deliveryType: 'home', shippingZone: null,
    notes: '' // <--- Campo para las preguntas/notas del cliente
  });

  useEffect(() => {
    localStorage.setItem('miCarritoAbejas', JSON.stringify(cart));
  }, [cart]);

  const handleAddToCart = (product, qty) => {
    setCart((prev) => {
      const exists = prev.find(item => item.id === product.id);
      if (exists) {
        return prev.map(item => item.id === product.id ? { ...item, qty: item.qty + qty } : item);
      }
      return [...prev, { ...product, qty, cartId: Date.now() }];
    });
  };

  const removeFromCart = (id) => {
    setCart((prev) => prev.filter(item => item.cartId !== id));
  };

  // --- LÓGICA DE ENVÍO FINAL (CON TOLERANCIA, NOTAS Y REDIRECCIÓN) ---
  const handleSendOrder = () => {
    // 1. Validación de tiempo para Pickup (Margen de 10 min)
    if (customer.deliveryType === 'pickup') {
      const ahora = new Date();
      const fechaSeleccionada = new Date(`${customer.pickupDate}T${customer.pickupTime}`);
      
      const margenTolerancia = 10 * 60000; 
      const tiempoMinimo = new Date(ahora.getTime() + margenTolerancia);

      if (isNaN(fechaSeleccionada.getTime())) {
        alert("Por favor selecciona una fecha y hora válidas.");
        return;
      }

      if (fechaSeleccionada < tiempoMinimo) {
        alert("Por seguridad, la cita debe ser con al menos 10 minutos de anticipación.");
        return;
      }
    }

    // 2. Construcción del mensaje usando la utilidad
    let message = createWhatsAppMessage(customer, cart);

    // 3. Nota Foránea Dinámica
    // (Asegúrate de que createWhatsAppMessage devuelva el texto plano para poder sumarle esto)
    if (customer.deliveryType === 'home' && customer.shippingZone === 'foraneo') {
        message += "\n\n⚠️ *Nota:* El costo de envío por paquetería (FedEx, DHL, Estafeta) se cotizará según volumen/peso del pedido.";
    }

    // 4. Agregar la nota del cliente si existe
    if (customer.notes && customer.notes.trim() !== '') {
        message += `\n\n💬 *Mensaje del cliente:* ${customer.notes}`;
    }

    // 5. Obtener URL final (Aquí se hace el encodeURIComponent)
    const whatsappURL = getWhatsAppURL(message);
    
    // 6. Redirección Inteligente para evitar bloqueos en móvil
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    if (isMobile) {
      // 'location.assign' es el método más seguro para disparar la App en móviles
      window.location.assign(whatsappURL);
    } else {
      window.open(whatsappURL, '_blank', 'noopener,noreferrer');
    }

    // Opcional: Si quieres vaciar el carrito al enviar, descomenta abajo:
    // setCart([]);
    // setIsCartOpen(false);
  };

  return (
    <Router>
      <Loader />
      <TopBar />
      <Header onOpenCart={() => setIsCartOpen(true)} cartCount={cart.length} />
      
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/catalog" element={<Catalog cart={cart} onAddToCart={handleAddToCart} />} />
        <Route path="/full-gallery" element={<FullGallery />} />
        <Route path="/faq" element={<FAQ />} /> 
      </Routes>

      <CartDrawer 
        isOpen={isCartOpen} 
        onClose={() => setIsCartOpen(false)} 
        cart={cart} 
        setCart={setCart} 
        removeFromCart={removeFromCart} 
        customer={customer} 
        setCustomer={setCustomer}
        token={token} 
        setToken={setToken} 
        handleSendOrder={handleSendOrder}
      />

      <Footer />
      <ScrollToTop />
    </Router>
  );
}

export default App;